<template>
  <div class="app-main-inner">
    <div style="width: fit-content">
      <div class="section">
        <el-form :disabled="readonly" :inline="true" label-position="left" label-width="75px">
          <el-form-item :label="$t('SeaExport.BusinessNo')">
            <!-- <el-input v-model="job.jobNo" :disabled="true" class="job-no-color" /> -->
            <el-input v-model="job.jobNo" :disabled="true" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.MblNo4')">
            <el-input :value="job.master?job.master.jobNo:''" :disabled="true" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CustomerReferenceNumber')">
            <cargo-input v-model="job.customerRefNo" :auto-uppercase="true" :trim="true" />
          </el-form-item>
          <el-checkbox v-model="job.warehousing">{{ $t('SeaExport.Storage') }}</el-checkbox>
          <el-checkbox v-model="job.international" style="margin-left: -20px;">{{ $t('SeaExport.InternationalTransport') }}</el-checkbox>
          <el-checkbox v-model="job.landTransportation" style="margin-left: -20px;">{{ $t('SeaExport.DeliveryToDoor') }}</el-checkbox>
          <el-checkbox v-model="job.customs" style="margin-left: -20px;" @change="job.customsBroker=job.customs?job.customsBroker:0;job.customsDeclarationType=job.customs?job.customsDeclarationType:-1">{{ $t('SeaExport.CustomsDeclaration') }}</el-checkbox>
          <el-checkbox v-model="job.insure" no="isInsure" style="margin-left: -20px;">{{ $t('SeaExport.InsureInfo') }} </el-checkbox>
          <el-checkbox v-model="job.itmService" style="margin-left: -20px;">{{ $t('SeaExport.ForeignTrade') }}</el-checkbox>
          <el-checkbox v-model="job.usCustomsClearance" style="margin-left: -20px;">{{ $t('queryJob.UsCustomsClearance') }}</el-checkbox>
          <span
            v-permission="['button_insurance_toInsure']"
            type="primary"
            :class="!isEdit?'el-button el-button--primary el-button--mini':'el-button el-button--primary el-button--mini is-disabled'"
            style="min-width:50px!important;margin-left:15px"
            @click="()=>{if (!isEdit){toInsure()}}"
          >{{ $t('SeaExport.Insure') }}
          </span>
        </el-form>
      </div>
      <div style="display: flex">
        <el-form label-position="right" label-width="120px" style="display: flex;">
          <div class="section form-column">
            <el-form-item>
              <span slot="label" class="blue">{{ job.cargoSource === 'NC' ? $t('SeaExport.ActualNotifyParty') : $t('SeaExport.ConsignationCompany') }}</span>
              <div style="display: flex;align-items: center">
                <el-tooltip v-show="sopImageA" no="sopImageA" :content="$t('SeaExport.SOPReceiver')" placement="right-end">
                  <!-- el-tooltip挂在div上（因为not-click样式会导致el-tooltip失效，所以不能挂在img上）-->
                  <div style="height: 28px;">
                    <img
                      :class="job.customerId&&readonly?'':'not-click'"
                      :src="sopPic"
                      width="18"
                      style="padding: 5px 0;cursor: pointer"
                      @click="showSopReceiverDialog('customer',job.customerId)"
                    >
                  </div>
                </el-tooltip>
                <el-tooltip v-show="creditTip.showWarningImageA" :content="creditTip.warningImageATip" placement="right-end">
                  <i class="el-icon-warning red" style="cursor: pointer" />
                </el-tooltip>
                <cargo-sales-company-select
                  no="customerId"
                  :disabled="customerEnabled"
                  :method-params="{customer:true,active:true,companyLob:'airImport'}"
                  :check-credit="true"
                  :default-value="job.customerId||''"
                  :placeholder="$t('SeaExport.RequiredItem')"
                  :job="job"
                  style="display: inline-block;width: 100%;"
                  @parentCallBack="p=>{txtCustomerId_changeHandler(p);clearPoNo()}"
                />
              </div>
            </el-form-item>
            <template v-if="isZY">
              <el-form-item>
                <span slot="label" class="blue">{{ $t('SeaExport.AllowSaleProduct') }}</span>
                <cargo-advance-select
                  :disabled="readonly"
                  :select-type="selectTypeNames.basic_data_AllowSaleProduct"
                  filterable
                  no="allowSaleProduct"
                  clearable
                  :data-filter-function="p => p.statusEnabled && p.airImportEnabled"
                  :default-value="job.saleProductCode || ''"
                  @parentCallBack="p => {job.saleProductCode = p.value}"
                />
              </el-form-item>
              <el-form-item>
                <span slot="label" class="blue">{{ $t('SeaExport.FullOrInside') }}</span>
                <cargo-advance-select
                  :disabled="readonly"
                  :select-type="selectTypeNames.local_cache_FullOrInside$FULL_OR_INSIDE"
                  no="fullOrInside"
                  clearable
                  :default-value="job.fullOrInside || ''"
                  @parentCallBack="p => {job.fullOrInside = p.value}"
                />
              </el-form-item>
            </template>
            <el-form-item :label="$t('SeaExport.CustomerProperty')">
              <el-tooltip :content="customerTip" placement="bottom">
                <span v-show="customerLevel.customerName" class="orange">LV{{ customerLevel.level }}</span>
                <span v-show="customerLevel.customerName" style="color:#D3A73B">&nbsp;{{ customerLevel.customerName }}</span>
                <span v-show="contractStatusLabel" class="red">&nbsp;({{ contractStatusLabel }})</span>
                <span v-show="advancePaymentLabel" style="color:brown">&nbsp;({{ advancePaymentLabel }})</span>
                <span v-show="stampPictureView.businessDocuments.length > 0" @click="stampPictureView.visible = true">
                  <img :title="$t('Message.BookingSeal')" :src="stampIcon" height="14" style="text-align: right;">
                </span>
              </el-tooltip>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ContactPerson')">
              <div style="display: flex;justify-content: space-between">
                <el-select v-model="job.customerContact" :disabled="readonly" no="customerContact" filterable :allow-create="true" placeholder=" ">
                  <el-option v-for="(item,index) in contactList" :key="index" :label="item.contactPerson" :value="item.contactPerson" />
                </el-select>
                <el-link v-show="!isShowContactPersonDetail" no="Detail" @click="contactInfoDialog.visible=true">{{ $t('SeaExport.Detail') }}</el-link>
              </div>
            </el-form-item>
            <el-form-item v-show="!isShowContactPersonDetail" :label="$t('SeaExport.Tel')">
              <el-input v-model="job.contactTelephone" :disabled="readonly" no="contactTelephone" />
            </el-form-item>
            <el-form-item v-show="!isShowContactPersonDetail" :label="$t('SeaExport.Fax')">
              <el-input v-model="job.contactFax" :disabled="readonly" no="contactFax" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SolicitationType')">
              <cargo-advance-select
                no="cargoSource"
                filterable
                :disabled="readonly"
                :select-type="selectTypeNames.local_cache_CargoSource"
                callback-method-type="value"
                :default-value="job.cargoSource"
                :callback-params="{key:'cargoSource'}"
                :clearable="false"
                placeholder=" "
                @parentCallBack="cargoSource_Change"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomJobType')">
              <cargo-advance-select
                ref="customJobType"
                no="customJobType"
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_CutomJobType"
                :clearable="true"
                :default-value="job.customJobType"
                :method-params="{type:job.lob}"
                :tag-name="isZh?'name':'englishName'"
                :static-options="customJobTypeList"
                @parentCallBack="p=>{job.customJobType=p.value;onCustomJobTypeChange(p)}"
              />
            </el-form-item>
            <el-form-item v-if="job.customJobType && secondaryCustomJobTypeList.length > 0" :label="$t('CargoMsg.Cargo_Grade')">
              <cargo-advance-select
                ref="secondaryCustomJobType"
                no="secondaryCustomJobType"
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_CutomJobType"
                filterable
                :cache="false"
                :default-value="job.secondaryCustomJobType"
                :tag-name="isZh?'name':'englishName'"
                :static-options="secondaryCustomJobTypeList"
                @parentCallBack="p=>{job.secondaryCustomJobType=p.value}"
              />
            </el-form-item>
            <el-form-item v-show="job.cargoSource==='NC'">
              <span slot="label" class="blue">{{ $t('SeaExport.NominatedAgent') }}</span>
              <div style="display: flex;align-items: center">
                <el-tooltip v-show="sopImageB" no="sopImageB" :content="$t('SeaExport.SOPReceiver')" placement="right-end">
                  <!-- el-tooltip挂在div上（因为not-click样式会导致el-tooltip失效，所以不能挂在img上）-->
                  <div style="height: 28px;">
                    <img
                      :class="job.designationAgent&&readonly?'':'not-click'"
                      :src="sopPic"
                      width="18"
                      style="padding: 5px 0;cursor: pointer"
                      @click="showSopReceiverDialog('DesignationAgent',job.designationAgent)"
                    >
                  </div>
                </el-tooltip>
                <el-tooltip v-show="creditTip.showWarningImageB" :content="creditTip.warningImageBTip" placement="right-end">
                  <i class="el-icon-warning" style="color: red;font-size: 18px; cursor: pointer" />
                </el-tooltip>
                <cargo-company-select
                  no="designationAgent"
                  :disabled="readonly"
                  :method-params="{overseaAgent:true,active:true}"
                  :check-credit="true"
                  :job="job"
                  :default-value="job.designationAgent||''"
                  tag-name="englishName"
                  :placeholder="$t('SeaExport.RequiredItem')"
                  style="display: inline-block;width: 100%;"
                  @change="designationAgentChangeHandler"
                />
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OrderChannels')">
              <el-input v-model="job.salesChannel" no="salesChannel" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ConsignationRelationNumber')">
              <el-input no="trustFromJob" :value="job.trustFromJob" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BusinessCommissionedRelationNumber')">
              <el-input no="relatedJob" :value="job.relatedJob" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PortOfLoadingAgent')">
              <div style="display: flex;align-items: center">
                <el-tooltip v-show="sopImageC" no="sopImageC" :content="$t('SeaExport.SOPReceiver')" placement="right-end">
                  <!-- el-tooltip挂在div上（因为not-click样式会导致el-tooltip失效，所以不能挂在img上）-->
                  <div style="height: 28px;">
                    <img
                      :class="job.loadingAgentId&&readonly?'':'not-click'"
                      :src="sopPic"
                      width="18"
                      style="padding: 5px 0;cursor: pointer"
                      @click="showSopReceiverDialog('PortOfLoadingAgent',job.loadingAgentId)"
                    >
                  </div>
                </el-tooltip>
                <el-tooltip v-show="creditTip.showWarningImageC" :content="creditTip.warningImageCTip" placement="right-end">
                  <i class="el-icon-warning" style="color: red;font-size: 18px;cursor: pointer" />
                </el-tooltip>
                <cargo-company-select
                  no="loadingAgentId"
                  :disabled="readonly"
                  :method-params="{overseaAgent:true,active:true}"
                  :check-credit="true"
                  :job="job"
                  :default-value="job.loadingAgentId||''"
                  tag-name="englishName"
                  style="display: inline-block;width: 100%;"
                  placeholder=" "
                  @change="loadingAgentChangeHandler"
                />
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.AirlineCompany')">
              <cargo-advance-select
                :disabled="readonly || !carrierIdEnabled"
                no="carrierId"
                filterable
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{airCmp:true,companyLob:'airImport',active:true}"
                :callback-params="{key:'carrierId'}"
                tag-name="chineseName"
                callback-method-type="value"
                :default-value="job.carrierId || ''"
                placeholder=" "
                @parentCallBack="p=>{setJobSelectNum(p);airlineCompanyChange(p.value||0)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Flight')">
              <cargo-input v-model="job.voyageFlight" :disabled="readonly || !isLclMasterFlag" no="voyageFlight" :auto-uppercase="true" />
            </el-form-item>
            <el-form-item v-if="bookingAgentVisible" :label="$t('SeaExport.BookingAgent')">
              <cargo-advance-select
                no="bookingAgent"
                filterable
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{bookingAgent:true,companyLob:'airImport',active:true}"
                :callback-params="{key:'bookingAgent'}"
                callback-method-type="value"
                :default-value="job.bookingAgent || ''"
                placeholder=" "
                @parentCallBack="obj=>{setJobSelectNum(obj);job.groundAgentId=job.bookingAgent}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BillExchangeAgent')">
              <cargo-advance-select
                no="exChangeAgent"
                filterable
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{bookingAgent:true,companyLob:'airImport',active:true}"
                :callback-params="{key:'exChangeAgent'}"
                callback-method-type="value"
                :default-value="job.exChangeAgent || ''"
                placeholder=" "
                @parentCallBack="obj=>{setJobSelectNum(obj);}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.MasterBillNo')">
              <el-tooltip :content="(job.express||mblCodeNumValidate)?'':$t('queryJob.TheDoesNotComplyRules')" placement="right-end">
                <div style="display: flex">
                  <el-checkbox v-model="job.express" :disabled="readonly" no="express">{{ $t('SeaExport.ExpressInfo') }}</el-checkbox>
                  <cargo-input v-show="job.express" v-model="job.mbl" :disabled="readonly" no="mbl" :maxlength="32" :auto-uppercase="true" />
                  <el-input
                    v-show="!job.express"
                    ref="mblCode"
                    :value="mblCode"
                    :disabled="readonly || !isLclMasterFlag"
                    no="mblCode"
                    maxlength="3"
                    :class="mblCodeNumValidate?'':'red'"
                    style="width: 80px;margin-left: 2px;"
                    @input="onMblCodeInput"
                    @blur="onMblCodeNumBlur"
                  />
                  <span v-show="!job.express" style="padding-right: 2px;padding-left: 1.5px;">-</span>
                  <cargo-input
                    v-show="!job.express"
                    ref="mblNum"
                    :value="mblNum"
                    :disabled="readonly || !isLclMasterFlag"
                    no="mblNum"
                    :maxlength="8"
                    :input-convert="filterNonDigit"
                    :class="mblCodeNumValidate?'':'red'"
                    style="width: 150px;"
                    @input="onMblNumInput"
                    @blur="onMblCodeNumBlur"
                  />
                </div>
              </el-tooltip>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SoNo')" style="margin-right: -3px;">
              <so-no-input v-model="job.jobSoNo" :disabled="readonly" no="jobSoNo" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Hbl2')">
              <cargo-input v-model="job.hbl" :disabled="readonly" no="hbl" :auto-uppercase="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PlaceOfReceipt')">
              <cargo-input v-model="job.dispatchingPlace" :disabled="readonly" no="dispatchingPlace" :auto-uppercase="true" />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.LoadingPort') }}</span>
              <div style="display: flex;justify-content: space-between">
                <el-input v-model="job.loadingPortCode" :disabled="true" no="loadingPortCode" style="width: 60px;margin-right: 5px;" />
                <cargo-advance-select
                  no="loadingPortCode"
                  filterable
                  :disabled="readonly"
                  :select-type="selectTypeNames.basic_data_Airport"
                  :default-value="valueMatch.loadingPortCode?job.loadingPortCode:''"
                  :placeholder="$t('SeaExport.RequiredItem')"
                  style="flex:1"
                  @parentCallBack="obj=>{valueMatch.loadingPortCode=true;loadingPortCodeChange(obj)}"
                />
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.PortOfDestination') }}</span>
              <div style="display: flex;justify-content: space-between">
                <el-input v-model="job.dischargingPortCode" :disabled="true" no="dischargingPortCode" style="width: 60px;margin-right: 5px;" />
                <cargo-advance-select
                  no="dischargingPortCode"
                  filterable
                  :disabled="readonly"
                  :select-type="selectTypeNames.basic_data_Airport"
                  :default-value="valueMatch.dischargingPortCode?job.dischargingPortCode:''"
                  :placeholder="$t('SeaExport.RequiredItem')"
                  style="flex:1"
                  @parentCallBack="dischargingPortCode_Change"
                />
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.FinalPlaceOfDelivery') }}</span>
              <cargo-input v-model="job.destinationPlace" :disabled="readonly" no="destinationPlace" :auto-uppercase="true" :placeholder="$t('SeaExport.RequiredItem')" />
            </el-form-item>
            <!--航线-->
            <el-form-item :label="$t('SeaExport.Airline')">
              <el-input v-model="job.regionName" no="airline" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomsBroker')">
              <cargo-advance-select
                :disabled="readonly || !job.customs"
                no="customsBroker"
                filterable
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{customsBroker:true,active:true}"
                callback-method-type="value"
                :default-value="job.customsBroker||''"
                placeholder=" "
                :callback-params="{key:'customsBroker'}"
                @parentCallBack="setJobSelectNum"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomsDeclarationMethod')">
              <cargo-advance-select
                no="customsMethod"
                :disabled="readonly || !job.customs"
                :select-type="selectTypeNames.basic_data_CustomsMode"
                :method-params="{serviceType:2}"
                tag-value="serialNum"
                filterable
                :default-value="job.customClaim"
                @parentCallBack="p=>{job.customClaim=p.value}"
              />
            </el-form-item>
            <el-form-item v-if="job.customClaim===1" :label="$t('SeaExport.CustomsDeclarationType')">
              <cargo-advance-select
                no="customsDeclarationType"
                :disabled="readonly || !job.customs"
                :select-type="selectTypeNames.basic_data_CustomsDeclarationType"
                filterable
                :default-value="job.customsDeclarationType===-1?'':job.customsDeclarationType"
                :placeholder="$t('CargoMsg.Cargo_keyWordsTip')"
                @parentCallBack="p=>{job.customsDeclarationType=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TradeMethod')">
              <cargo-advance-select
                no="tradeTerm"
                filterable
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_TradeTerm"
                callback-method-type="value"
                :default-value="job.tradeTerm"
                :callback-params="{key:'tradeTerm'}"
                :clearable="false"
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CategoryOfGoods')">
              <cargo-advance-select
                no="cargoCode"
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_CargoInformation"
                filterable
                :callback-params="{key:'cargoCode'}"
                :default-value="job.cargoCode"
                placeholder=" "
                @parentCallBack="txtCargoInformationChangeHandler"
              />
            </el-form-item>
            <el-form-item>
              <cargo-input v-model="job.cargoName" :disabled="readonly || !job.cargoCode" no="cargoName" />
            </el-form-item>
            <el-form-item :label="$t('Message.TerminalAddress')">
              <cargo-rich-textarea
                v-model="job.deliveryAddress"
                no="deliveryAddress"
                :disabled="readonly"
                style="height: 110px;"
                @dblclick.native="showAdvanceTextDialog($t('Message.TerminalAddress'),job.deliveryAddress, undefined, val=>{job.deliveryAddress=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_TransportSource')">
              <cargo-advance-select
                filterable
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_TransportSource"
                no="transportSource"
                :default-value="job.transportSource"
                :cache="false"
                tag-value="code"
                placeholder=" "
                @parentCallBack="item=>job.transportSource=item.value"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_ServiceStatisticalArea')">
              <cargo-advance-select
                filterable
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_StatisticArea"
                no="statisticArea"
                :default-value="job.statisticArea"
                :cache="false"
                tag-value="code"
                placeholder=" "
                @parentCallBack="item=>job.statisticArea=item.value"
              />
            </el-form-item>
          </div>
          <div class="section form-column" style="width: 350px">
            <el-form-item :label="$t('SeaExport.OperationDate')" label-width="120px">
              <el-date-picker v-model="job.customsDate" :disabled="readonly" no="customsDate" type="date" value-format="yyyy-MM-dd" style="width: 100%" clearable />
            </el-form-item>
            <el-form-item label-width="120px">
              <span slot="label">{{ $t('SeaExport.DateOfDeparture2') }}</span>
              <div style="display: flex">
                <el-date-picker
                  ref="etd"
                  v-model="job.etd"
                  :default-value="new Date()"
                  :disabled="readonly || !isLclMasterFlag"
                  no="etd"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm"
                  value-format="yyyy-MM-dd HH:mm"
                  placeholder=" "
                  style="flex: 1; width:170px; margin-right: 5px"
                  clearable
                  @input="etdChange"
                  @blur="()=> { handleBlur('etd', etdChange, false, false, job) }"
                />
                <span>{{ job.sailingDay|filterWeek }}</span>
              </div>
            </el-form-item>
            <el-form-item label-width="120px">
              <span slot="label" class="blue">{{ $t('SeaExport.DateOfArrival2') }}</span>
              <div style="display: flex">
                <el-date-picker
                  ref="eta"
                  v-model="job.eta"
                  :default-value="new Date()"
                  :disabled="readonly || !isLclMasterFlag || provisionEtdLocked"
                  no="eta"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm"
                  value-format="yyyy-MM-dd HH:mm"
                  :placeholder="$t('SeaExport.RequiredItem')"
                  style="flex: 1; width:170px; margin-right: 5px"
                  clearable
                  @change="etaChange"
                  @blur="()=> { handleBlur('eta', etaChange, false, false, job) }"
                />
                <span>{{ job.etaSailingDay|filterWeek }}</span>
              </div>
              <span v-if="provisionEtdLocked" style="color: red; font-size: 12px;">(已计提校准不可修改)</span>
            </el-form-item>
            <el-form-item label-width="120px">
              <span slot="label">{{ $t('SeaExport.ActualDateOfDeparture2') }}</span>
              <div style="display: flex">
                <el-date-picker
                  ref="atd"
                  v-model="job.atd"
                  :default-value="new Date()"
                  :disabled="readonly || !isLclMasterFlag"
                  no="atd"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm"
                  value-format="yyyy-MM-dd HH:mm"
                  style="flex: 1; width:170px; margin-right: 5px"
                  clearable
                  @input="atdChange"
                  @blur="()=> { handleBlur('atd', atdChange, false, false, job) }"
                />
                <span>{{ job.atdSailingDay|filterWeek }}</span>
              </div>
            </el-form-item>
            <el-form-item label-width="120px">
              <span slot="label">{{ $t('SeaExport.ActualDateOfArrival2') }}</span>
              <div style="display: flex">
                <el-date-picker
                  ref="ata"
                  v-model="job.ata"
                  :default-value="new Date()"
                  :disabled="readonly || !isLclMasterFlag"
                  no="ata"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm"
                  value-format="yyyy-MM-dd HH:mm"
                  style="flex: 1; width:170px; margin-right: 5px"
                  clearable
                  @input="ataChange"
                  @blur="()=> { handleBlur('ata', ataChange, false, false, job) }"
                />
                <span>{{ job.ataSailingDay|filterWeek }}</span>
              </div>
            </el-form-item>
            <el-form-item label-width="120px">
              <div style="display: flex;justify-content: flex-end">
                <el-button type="primary" :disabled="readonly" no="CopyFromOtherBill" @click="importPromptTitleDialog.visible=true">{{ $t('SeaExport.CopyFromOtherBill') }}</el-button>
                <el-button type="primary" :disabled="readonly" no="CodeSearching" @click="billAddressDialog.visible=true">{{ $t('SeaExport.CodeSearching') }}</el-button>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Shipper')" label-width="120px">
              <div style="display: flex;justify-content: space-between;margin-bottom: 10px">
                <cargo-input v-model="job.shipperCode" :disabled="readonly" no="shipperCode" :auto-uppercase="notUppercaseShipperConsigneNotify" :placeholder="readonly ? '': $t('Tool.Code')" style="width:90px;margin-right: 5px" @change="syncHbl('shipperCode')" />
                <cargo-advance-select
                  no="shipperId"
                  filterable
                  :disabled="readonly"
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{shipper:true,active:true}"
                  :default-value="job.shipperId||''"
                  tag-name="englishName"
                  style="flex: 1"
                  placeholder=" "
                  @parentCallBack="shipperAutoCompleteChange"
                />
              </div>
            </el-form-item>
            <el-form-item v-for="i in 1" v-if="i>=1" :key="'shipperLine'+i" label-width="120px" style="margin-top: -10px">
              <cargo-input
                :ref="'shipperLine'+i"
                v-model="job['shipperLine'+i]"
                :disabled="readonly"
                no="shipperLine1"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                :use-read-only="true"
                :placeholder="readonly ? '': $t('queryJob.DoubleOfLadingHeaderUp')"
                @change="syncHbl('shipperLine1')"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.Shipper'),mergeShipperLine(),undefined,splitShipperLine)"
              />
              <char-count inline :form="job" prefix="shipper" style="float:right" />
            </el-form-item>
            <el-form-item v-for="i in 7" v-if="i>=2" v-show="false" :key="'shipperLine'+i" label-width="120px">
              <cargo-input
                :ref="'shipperLine'+i"
                v-model="job['shipperLine'+i]"
                :disabled="readonly"
                :use-read-only="true"
                no="'shipperLine'+i"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Consignee')" label-width="120px">
              <div style="display: flex;justify-content: space-between;margin-bottom: 10px">
                <cargo-input v-model="job.consigneeCode" :disabled="readonly" no="consigneeCode" :auto-uppercase="notUppercaseShipperConsigneNotify" :placeholder="readonly ? '': $t('Tool.Code')" style="width:90px;margin-right: 5px" @change="syncHbl('consigneeCode')" />
                <cargo-advance-select
                  no="consigneeId"
                  filterable
                  :disabled="readonly"
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{consignee:true}"
                  :default-value="job.consigneeId||''"
                  tag-name="englishName"
                  style="flex: 1"
                  placeholder=" "
                  @parentCallBack="consigneeAutoCompleteChange"
                />
              </div>
            </el-form-item>
            <el-form-item v-for="i in 1" v-if="i>=1" :key="'consigneeLine'+i" label-width="120px" style="margin-top: -10px">
              <cargo-input
                :ref="'consigneeLine'+i"
                v-model="job['consigneeLine'+i]"
                :disabled="readonly"
                no="consigneeLine1"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                :use-read-only="true"
                :placeholder="readonly ? '': $t('queryJob.DoubleOfLadingHeaderUp')"
                @change="syncHbl('consigneeLine1')"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.Consignee'),mergeConsigneeLine(),undefined,splitConsigneeLine)"
              />
              <char-count inline :form="job" prefix="consignee" style="float:right" />
            </el-form-item>
            <el-form-item v-for="i in 7" v-if="i>1" v-show="false" :key="'consigneeLine'+i" label-width="120px">
              <cargo-input
                :ref="'consigneeLine'+i"
                v-model="job['consigneeLine'+i]"
                :disabled="readonly"
                :use-read-only="true"
                no="'consigneeLine'+i"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.NotifyParty')" label-width="120px">
              <div style="display: flex;justify-content: space-between;margin-bottom: 10px">
                <cargo-input v-model="job.notifyCode" :disabled="readonly" no="notifyCode" :auto-uppercase="notUppercaseShipperConsigneNotify" :placeholder="readonly ? '': $t('Tool.Code')" style="width:90px;margin-right: 5px" @change="syncHbl('notifyCode')" />
                <cargo-advance-select
                  no="notifyId"
                  filterable
                  :disabled="readonly"
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{notify:true}"
                  :default-value="job.notifyId||''"
                  tag-name="englishName"
                  style="flex: 1"
                  placeholder=" "
                  @parentCallBack="notifyAutoCompleteChange"
                />
              </div>
            </el-form-item>
            <el-form-item v-for="i in 1" v-if="i>=1" :key="'notifyLine'+i" label-width="120px" style="margin-top: -10px">
              <cargo-input
                :ref="'notifyLine'+i"
                v-model="job['notifyLine'+i]"
                :disabled="readonly"
                no="notifyLine1"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                :use-read-only="true"
                :placeholder="readonly ? '': $t('queryJob.DoubleOfLadingHeaderUp')"
                @change="syncHbl('notifyLine1')"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.NotifyParty'),mergeNotifyLine(),undefined,splitNotifyLine)"
              />
              <char-count inline :form="job" prefix="notify" style="float:right" />
            </el-form-item>
            <el-form-item v-for="i in 7" v-if="i>1" v-show="false" :key="'notifyLine'+i" label-width="120px">
              <cargo-input
                :ref="'notifyLine'+i"
                v-model="job['notifyLine'+i]"
                :disabled="readonly"
                :use-read-only="true"
                no="'notifyLine'+i"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ActualQuantity')" label-width="120px">
              <auto-number-input
                v-model="job.quantityActual"
                :disabled="readonly"
                no="quantityContract"
                :precision="0"
                :min="0"
                @change="quantityChange"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Package')" label-width="120px">
              <!-- <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_Packing"
                :method-params="{}"
                callback-method-type="value"
                :default-value="job.packing+''"
                tag-name="chineseName"
                :callback-params="{key:'packing'}"
                @parentCallBack="setJobSelectValue"
              /> -->
              <cargo-packing-select
                no="packing"
                :disabled="readonly"
                :default-value="job.packing"
                placeholder=" "
                @change="p => {p.key = 'packing';setJobSelectValue(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ActualWeight')" label-width="120px">
              <div style="display: flex">
                <auto-number-input
                  v-model="job.weightActual"
                  :disabled="readonly"
                  no="weightContract"
                  :precision="3"
                  :min="0"
                  @change="weightContractChange"
                />
                <div style="font-size: 12px;font-weight: normal;color: #404144">
                  <span>KGS</span>
                </div>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ActualVolume')" label-width="120px">
              <div style="display: flex">
                <auto-number-input
                  v-model="job.cubageActual"
                  :disabled="readonly"
                  no="cubageContract"
                  :precision="3"
                  :min="0"
                  @change="cubageContractChange"
                />
                <div style="font-size: 12px;font-weight: normal;color: #404144">
                  <span>CBM</span>
                </div>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ChargedWeight')" label-width="120px">
              <auto-number-input
                v-model="job.chargeWeight"
                :disabled="readonly"
                no="chargeWeight"
                :precision="3"
                :min="0"
                @change="syncChargeWeightToCharge();syncHbl('chargeWeight', 'cWeight')"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ChineseDescriptionOfGoods')" label-width="120px">
              <cargo-input
                v-model="job.cargoChineseName"
                :disabled="readonly"
                no="cargoChineseName"
                type="textarea"
                :rows="3"
                :auto-uppercase="true"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.ChineseDescriptionOfGoods'),job.cargoChineseName,0,val=>{job.cargoChineseName=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.EnglishDescriptionOfGoods')" label-width="120px">
              <div style="position:relative">
                <cargo-input
                  v-model="job.cargoEnglishName"
                  :disabled="readonly"
                  no="cargoEnglishName"
                  type="textarea"
                  :rows="3"
                  :auto-uppercase="isUppercaseByConfig"
                  @change="syncHbl('cargoEnglishName')"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.EnglishDescriptionOfGoods'),job.cargoEnglishName,0,val=>{job.cargoEnglishName=val},isUppercaseByConfig)"
                />
                <char-count :value="job.cargoEnglishName" />
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Marks')" label-width="120px">
              <div style="position:relative">
                <cargo-input
                  v-model="job.mark"
                  :disabled="readonly"
                  no="mark"
                  type="textarea"
                  :rows="3"
                  :auto-uppercase="isUppercaseByConfig"
                  @change="syncHbl('mark', 'remark1')"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.Marks'),job.mark,0,val=>{job.mark=val},isUppercaseByConfig)"
                />
                <char-count :value="job.mark" />
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PreCollection')" label-width="120px">
              <div style="display: flex;justify-content: space-between">
                <el-input-number v-model="job.depositReceived" :disabled="readonly" no="depositReceived" style="flex-grow: 1" :controls="false" :precision="3" />
                <span>{{ localCurrency }}</span>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Remarks')" label-width="120px">
              <cargo-input
                v-model="job.remarks"
                :disabled="readonly"
                no="remarks"
                type="textarea"
                :rows="3"
                :auto-uppercase="true"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.Remarks'),job.remarks,0,val=>{job.remarks=val})"
              />
            </el-form-item>
          </div>
          <div class="section form-column">
            <el-form-item :label="$t('SeaExport.ItemNo')" :class="poNoRed?'poNoClass':''">
              <cargo-input v-if="!openProjectConfig" v-model="job.poNo" :disabled="readonly" no="poNo" :auto-uppercase="true" />
              <cargo-project-select
                v-if="openProjectConfig"
                :disabled="readonly"
                no="poNo"
                :default-value="job.poNo"
                :customer-id="job.customerId"
                @change="changeProject"
              />
            </el-form-item>
            <el-form-item
              v-if="openProjectConfig"
              :label="$t('SeaExport.ProjectName')"
            >
              <el-input v-model="job.projectName" :disabled="true" no="projectName" />
            </el-form-item>
            <el-form-item
              v-if="openProjectConfig"
              :label="$t('SeaExport.ProjectBatch')"
            >
              <el-input v-model="job.projectBatch" no="projectBatch" :disabled="readonly" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OperateType')">
              <cargo-advance-select
                :disabled="readonly || !isLclMasterFlag"
                no="operateType"
                filterable
                :select-type="selectTypeNames.local_cache_ImportConstants$_cargoTypeAirInputList"
                callback-method-type="value"
                :default-value="job.operateType"
                :callback-params="{key:'operateType'}"
                :clearable="false"
                @parentCallBack="operateType_changeHandler"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TransportationClause')">
              <cargo-advance-select
                no="freightTerm"
                filterable
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_ShippingTerm"
                callback-method-type="value"
                :default-value="job.freightTerm"
                :callback-params="{key:'freightTerm'}"
                :clearable="false"
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CargoType')">
              <cargo-advance-select
                no="cargoType"
                filterable
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_CargoType"
                :method-params="{air:true}"
                callback-method-type="value"
                :default-value="job.cargoType"
                :callback-params="{key:'cargoType'}"
                :clearable="false"
                @parentCallBack="onCargoTypeChagne"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.HBLFreightClause')">
              <cargo-advance-select
                no="paymentTermHBL"
                filterable
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_PaymentTerm"
                callback-method-type="value"
                :default-value="job.paymentTermHBL"
                :callback-params="{key:'paymentTermHBL'}"
                :clearable="false"
                placeholder=" "
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.MasterBLFreightTerm')">
              <cargo-advance-select
                :disabled="readonly || !isLclMasterFlag"
                no="paymentTermMBL"
                filterable
                :select-type="selectTypeNames.basic_data_PaymentTerm"
                callback-method-type="value"
                :default-value="job.paymentTermMBL"
                :callback-params="{key:'paymentTermMBL'}"
                :clearable="false"
                placeholder=" "
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TradeTerms2')">
              <cargo-advance-select
                no="incoTerm"
                filterable
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_IncoTerm"
                callback-method-type="value"
                :default-value="job.incoTerm"
                :callback-params="{key:'incoTerm'}"
                :clearable="false"
                placeholder=" "
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BillExchangeDate')">
              <el-date-picker v-model="job.transDate" :disabled="readonly" no="transDate" type="date" value-format="yyyy-MM-dd" style="width:100%;" clearable />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DateOfDelivery')">
              <el-date-picker v-model="job.deliverDate" :disabled="readonly" no="deliverDate" type="date" value-format="yyyy-MM-dd" style="width:100%;" clearable />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DateOfArrivalTheWarehouse')">
              <el-date-picker v-model="job.arriveStorageDate" :disabled="readonly" no="arriveStorageDate" type="date" value-format="yyyy-MM-dd" style="width:100%;" clearable />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.AirportHandlingAgent')">
              <cargo-advance-select
                no="groundAgentId"
                filterable
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{bookingAgent:true,active:true}"
                :callback-params="{key:'groundAgentId'}"
                callback-method-type="value"
                :default-value="job.groundAgentId||''"
                placeholder=" "
                @parentCallBack="setJobSelectNum"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SalesCompany')">
              <el-input v-model="txtSalesOffice" :disabled="true" no="txtSalesOffice" :placeholder="$t('SeaExport.RequiredItem')" />
            </el-form-item>
            <el-form-item>
              <span slot="label" :class="job.cargoSource!=='NC'?'blue':''">{{ $t('SeaExport.Sales') }}</span>
              <div style="display: flex;justify-content: space-between">
                <cargo-user-select
                  ref="sales"
                  :disabled="readonly || isWithinCloseAccountDate"
                  no="sales"
                  :method-params="{officeId:salesOfficeCheck?$store.getters.currentOfficeId:'',category:'role',shape:'sales'}"
                  :default-value="job.sales||''"
                  :static-options="salesList"
                  style="flex: 1"
                  placeholder=" "
                  @change="salesChangeHandler"
                />
                <el-checkbox
                  v-model="job.provisioned"
                  :disabled="true"
                  no="provisioned"
                  style="margin-left: 5px;margin-right: 0px;"
                >{{ $t('SeaExport.Accrued') }}</el-checkbox>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SalesOfGoods')">
              <cargo-user-select
                no="cargoSalesId"
                :disabled="readonly"
                :method-params="{category:'role',shape:'salesOfGoods'}"
                :default-value="job.cargoSalesId||''"
                placeholder=" "
                :static-options="cargoSalesList"
                @change="cargoSalesChargeHandler"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" :class="job.cargoSource==='SC'?'blue':''">{{ $t('SeaExport.SalesDepartment') }}</span>
              <cargo-department-new-select
                :disabled="readonly || !job.sales"
                no="salesOffice"
                :sales-id="Number(job.sales)"
                :enables="true"
                :office-id="job.salesOffice"
                :department-id="Number(job.salesDepartment)"
                placeholder=" "
                @change="departmentChangeHandler"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OperationCompany')">
              <cargo-advance-select
                no="opOffice"
                :disabled="readonly || opOfficeDisabled"
                :select-type="selectTypeNames.basic_data_Office"
                filterable
                :callback-params="{key:'opOffice'}"
                :static-options="cacheOffices"
                callback-method-type="value"
                :default-value="job.opOffice||''"
                placeholder=" "
                @parentCallBack="p=>{setJobSelectNum(p);job.opDepartment=0;opOfficeChargeHandler();contractRuleFieldChange(job.customerId, job.designationAgent)}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_OperationDepartment') }}</span>
              <cargo-department-select
                :disabled="readonly || isWithinCloseAccountDate"
                no="opDepartment"
                :office-id="Number(job.opOffice)"
                :enables="true"
                :department-id="Number(job.opDepartment)"
                placeholder=" "
                @change="p=>{job.opDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerOffice')">
              <cargo-office-select
                no="csrOffice"
                :disabled="true"
                :office-id="Number(job.csrOffice)"
                @change="p=>{job.csrOffice=p.value;job.csrDepartment=0}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('Message.Customer_Service') }}</span>
              <cargo-department-select
                no="csrDepartment"
                :disabled="readonly"
                :office-id="Number(job.csrOffice)"
                :enables="true"
                :department-id="Number(job.csrDepartment)"
                @change="p=>{job.csrDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerService')">
              <cargo-user-select
                no="csr"
                :disabled="readonly"
                :method-params="{category:'role',shape:'csr'}"
                :default-value="job.csr||''"
                placeholder=" "
                :static-options="userPortRoleData.csr"
                @change="csrChangeHandler"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Operation')">
              <cargo-user-select no="op" :disabled="readonly" :method-params="{category:'role',shape:'op',officeId:$store.getters.currentOffice.code==='HB'?'':$store.getters.currentOfficeId}" :default-value="job.op||''" placeholder=" " :static-options="userPortRoleData.op" @change="opChangeHandler" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DocumentOffice')">
              <cargo-office-select
                no="dcOffice"
                :disabled="true"
                :office-id="Number(job.dcOffice)"
                @change="p=>{job.dcOffice=p.value;job.dcDepartment=0}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('Message.Documentation_Department') }}</span>
              <cargo-department-select
                no="dcDepartment"
                :disabled="readonly"
                :office-id="Number(job.dcOffice)"
                :enables="true"
                :department-id="Number(job.dcDepartment)"
                @change="p=>{job.dcDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Documents')">
              <cargo-user-select no="dc" :disabled="readonly" :method-params="{category:'role',shape:'doc'}" :default-value="job.dc||''" placeholder=" " :static-options="userPortRoleData.doc" @change="dcChangeHandler" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.AirlineOffice')">
              <cargo-office-select
                no="plannerOffice"
                :disabled="true"
                :office-id="Number(job.plannerOffice)"
                @change="p=>{job.plannerOffice=p.value;job.plannerDepartment=0}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('SeaExport.AirlineDepartment') }}</span>
              <cargo-department-select
                no="plannerDepartment"
                :disabled="readonly"
                :office-id="Number(job.plannerOffice)"
                :enables="true"
                :department-id="Number(job.plannerDepartment)"
                @change="p=>{job.plannerDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_AirlinePerson')">
              <cargo-user-select
                no="planner"
                :disabled="readonly"
                :method-params="{category:'role',shape:'airline'}"
                :default-value="job.planner||''"
                placeholder=" "
                :static-options="userPortRoleData.airline"
                @change="plannerChangeHandler"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PolOperation')">
              <cargo-user-select
                no="loadingPortOp"
                :disabled="readonly"
                :method-params="{category:'role',shape:'aiop'}"
                :default-value="job.loadingPortOp||''"
                placeholder=" "
                @change="p=>{job.loadingPortOp=p.value||0}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PodOperation')">
              <cargo-user-select
                no="destinationPortOp"
                :disabled="readonly"
                :method-params="{category:'role',shape:'aiop'}"
                :default-value="job.destinationPortOp||''"
                placeholder=" "
                @change="p=>{job.destinationPortOp=p.value||0}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.FieldOperation')">
              <cargo-user-select
                :disabled="readonly"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'siteOp'}"
                :default-value="job.siteOP||''"
                placeholder=" "
                :static-options="userPortRoleData.siteOp"
                @change="p=>{JobUtils.siteOpChangeHandler(job, p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OverseaCustomerService')">
              <cargo-user-select
                ref="overseaOp"
                no="overseaOp"
                class="input2"
                :disabled="readonly"
                :default-value="job.overseaOp||''"
                :method-params="{category:'role',shape:'overseaOp'}"
                :static-options="isHC ? null : (userPortRoleData.overseaOp || overseaAgentUsersList)"
                :merge-load="true"
                @change="p=>{
                  job.overseaOp = p.value
                  OverseaCustomerUtils.overseaOpChangeHandler(view, p)
                }"
              />
            </el-form-item>
            <el-form-item v-show="isAddUserDefinedRoles" :label="$t('CargoMsg.Cargo_userDefinedRole1')">
              <cargo-user-select
                ref="userDefinedRoleId1"
                no="userDefinedRoleId1"
                :disabled="readonly"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole1'}"
                :default-value="job.userDefinedRoleId1||''"
                :merge-load="true"
                placeholder=" "
                @change="p=>{userDefinedRoleId1Handler(p)}"
              />
            </el-form-item>
            <el-form-item v-show="isAddUserDefinedRoles" :label="$t('CargoMsg.Cargo_userDefinedRole2')">
              <cargo-user-select
                ref="userDefinedRoleId2"
                no="userDefinedRoleId2"
                :disabled="readonly"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole2'}"
                :default-value="job.userDefinedRoleId2||''"
                :merge-load="true"
                placeholder=" "
                @change="p=>{userDefinedRoleId2Handler(p)}"
              />
            </el-form-item>
            <div>
              <special-requests-grid
                v-model="job.satisfiedRequests"
                :disabled="readonly"
                no="satisfiedRequests"
                :is-edit="isEdit"
                :customer-id="Number(job.customerId)"
                :lob="job.lob"
                :job="job"
              />
            </div>
          </div>
          <div class="section form-column">
            <el-form-item :label="$t('SeaExport.UserDefinedField1')">
              <el-input
                v-model="job.userDefinedField1"
                :disabled="readonly"
                no="userDefinedField1"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField1'),job.userDefinedField1,0,val=>{job.userDefinedField1=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UserDefinedField2')">
              <el-input
                v-model="job.userDefinedField2"
                :disabled="readonly"
                no="userDefinedField2"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField2'),job.userDefinedField2,0,val=>{job.userDefinedField2=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UserDefinedField3')">
              <el-input
                v-model="job.userDefinedField3"
                :disabled="readonly"
                no="userDefinedField3"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField3'),job.userDefinedField3,0,val=>{job.userDefinedField3=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UserDefinedField4')">
              <el-input
                v-model="job.userDefinedField4"
                :disabled="readonly"
                no="userDefinedField4"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField4'),job.userDefinedField4,0,val=>{job.userDefinedField4=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TaxNature')">
              <el-select
                v-model="job.taxNature"
                :disabled="readonly"
                no="taxNature"
                :placeholder="$t('SeaExport.PleaseSelect')"
                size="mini"
              >
                <el-option
                  v-for="(item,index) in TAX_NATURES"
                  :key="index"
                  :label="isZh?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>&nbsp;
            </el-form-item>
          </div>
        </el-form>
      </div>
      <!-- SOP接收人弹窗 -->
      <sop-dialog
        :visible.sync="sopDialog.visible"
        :cmp-idx="sopDialog.cmpIdx"
        :job="job"
        :agent="sopDialog.agent"
        lob="AI"
        :contact-list="sopDialog.contactList"
        @updateJob="$emit('updateJob')"
      />
      <cargo-contacts-info-dialog
        v-if="contactInfoDialog.visible"
        :visible.sync="contactInfoDialog.visible"
        :customer-id="job.customerId"
        :customer-contact="job.customerContact"
      />
      <!-- 单号抄录 -->
      <import-prompt-title-dialog :visible.sync="importPromptTitleDialog.visible" :lob="job.lob" @selected="onExcerptionChangeFunc" />
      <!-- 代码检索 -->
      <import-bill-address-title-dialog :visible.sync="billAddressDialog.visible" :job="job" @callback="codeSearchCallback" />
      <!-- 高级文本弹框 -->
      <el-dialog
        v-el-drag-dialog
        :visible.sync="advanceTextDialog.visible"
        :title="advanceTextDialog.title"
        width="665px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <cargo-rich-textarea
          v-model="advanceTextDialog.value"
          :disabled="readonly"
          :text-chars="advanceTextDialog.textChars"
          :auto-uppercase="advanceTextDialog.isUppercase"
          :warning-count="-1"
          style="height: 320px;"
        />
        <span slot="footer">
          <el-button v-show="isEdit" no="confirm" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
          <el-button no="close" @click="advanceTextDialog.visible=false">{{ $t('common.btn.close') }}</el-button>
        </span>
      </el-dialog>
      <!-- 订舱章弹窗 -->
      <stamp-picture-view
        :visible.sync="stampPictureView.visible"
        :business-documents="stampPictureView.businessDocuments"
      />
    </div>
  </div>
</template>

<script>
import tabBookingFCLJS from './tabBookingFCL.js'
import sopPic from '@/assets/sop.png'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect'
import cargoDepartmentNewSelect from '@/components/Cargo/Common/cargoDepartmentNewSelect'
import cargoInput from '@/components/Cargo/Common/cargoInput'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import cargoProjectSelect from '@/components/Cargo/Common/cargoProjectSelect'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import cargoContactsInfoDialog from '@/components/Cargo/Job/cargoContactsInfoDialog'
import SpecialRequestsGrid from '@/components/Cargo/Job/specialRequestsGrid'
import ImportPromptTitleDialog from '@/components/Cargo/Job/importPromptTitleDialog'
import ImportBillAddressTitleDialog from '@/components/Cargo/Job/importBillAddressTitleDialog'
import cargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import sopDialog from '@/components/Cargo/Job/sopDialog'
import soNoInput from '@/components/Cargo/Job/soNoInput'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { AirImportJob } from '@/class/model/booking/AirImportJob'
import StampPictureView from '@/components/Cargo/Job/stampPictureView'
import stampIcon from '@/assets/stamp.jpg'
import lang from '@/lang'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { OverseaCustomerUtils } from '@/class/cargo/model/utils/OverseaCustomerUtils'
import CargoSalesCompanySelect from '@/components/Cargo/Common/cargoSalesCompanySelect'
import { getBranchByLevel } from '@/utils/basicDataCache'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect.vue'
import { BillAddressCommonPM } from '@/class/common/BillAddressCommonPM'
import BasicTabMixin from '@/mixin/BasicTabMixin'
import { cache } from '@/utils/cacheManager'
import { handleBlur } from '@/utils/commonUtil'
import { RATE_TYPE, TAX_NATURES } from '@/class/cargo/model/parameters/SystemConstants'
import { checkJobProvisionFlag } from '@/api/provision/provisionData'

export default {
  name: 'AiTabBookingFCL',
  filters: {
    filterWeek(val) {
      switch (val) {
        case 'TUE':
          return lang.t('SeaExport.TUE')
        case 'WED':
          return lang.t('SeaExport.WED')
        case 'THU':
          return lang.t('SeaExport.THU')
        case 'FRI':
          return lang.t('SeaExport.FRI')
        case 'SAT':
          return lang.t('SeaExport.SAT')
        case 'SUN':
          return lang.t('Pricing.Sun')
        case 'MON':
        default:
          return lang.t('SeaExport.MON')
      }
    }
  },
  components: {
    cargoOfficeSelect,
    StampPictureView, cargoPackingSelect, AutoNumberInput,
    cargoAdvanceSelect, cargoDepartmentSelect, cargoDepartmentNewSelect, cargoInput, cargoCompanySelect, cargoUserSelect, cargoProjectSelect, cargoRichTextarea, cargoContactsInfoDialog, SpecialRequestsGrid, ImportPromptTitleDialog, ImportBillAddressTitleDialog, sopDialog,
    soNoInput, CargoSalesCompanySelect
  },
  mixins: [BasicTabMixin],
  props: {
    context: { type: Object, required: true },
    action: { type: String, required: true },
    viewSource: { type: String, default: '' }, // 页面请求发起方
    cooperateEdit: { type: Boolean, default: true }, // 能否修改
    bookingAgentVisible: { type: Boolean, default: true },
    processingPromiseList: { // 正在处理中的异步操作对象列表
      type: Array,
      default: () => []
    },
    provisionLock: {
      type: Object,
      default: () => ({ etdLocked: false, feeLocked: false })
    }
  },
  data() {
    return {
      handleBlur,
      isZh: this.$store.getters.language === 'zh',
      sopPic,
      salesOfficeCheck: false,
      isWithinCloseAccountDate: false,
      TAX_NATURES,
      rateType: RATE_TYPE,
      job: new AirImportJob().fillDefaultValue().getData(),
      sopImageA: false,
      sopImageB: false,
      sopImageC: false,
      openProjectConfig: false,
      creditTip: { // 信控超期提醒
        showWarningImageA: false,
        warningImageATip: '',
        showWarningImageB: false,
        warningImageBTip: '',
        showWarningImageC: false,
        warningImageCTip: ''
      },
      customerLevel: {
        level: '',
        customerName: ''
      },
      advancePaymentLabel: '', // 预付款(中邮)
      contractStatusLabel: '',
      customerTip: '',
      contactList: [],
      mblCode: '',
      mblNum: '',
      mblCodeNumValidate: true,
      txtSalesOffice: '', // 销售所在分公司
      salesList: null,
      valueMatch: {
        loadingPortCode: false,
        dischargingPortCode: false
      },
      sopDialog: {
        visible: false,
        cmpIdx: 0,
        agent: '',
        contactList: []
      },
      contactInfoDialog: {
        visible: false
      },
      importPromptTitleDialog: {
        visible: false
      },
      billAddressDialog: {
        visible: false
      },
      stampIcon, // 订舱章
      stampPictureView: {
        businessDocuments: [], // 不为空则显示订舱章
        visible: false
      },
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        textChars: undefined,
        successCallback: null,
        isUppercase: false
      },
      isAddUserDefinedRoles: false, // 是否显示自定义岗位
      loadingPortChanged: false, // 起运港是否发生变更
      JobUtils,
      overseaAgentUsersList: [], // 海外客服用户列表
      OverseaCustomerUtils,
      view: this,
      poNoRed: false,
      needConfirmProjectNo: false,
      addrPM: new BillAddressCommonPM(this),
      userPortRoleData: {
        userDefinedRole1: null,
        userDefinedRole2: null,
        userDefinedRole3: null,
        userDefinedRole4: null,
        overseaOp: null,
        siteOp: null,
        doc: null,
        csr: null,
        op: null,
        seaLine: null,
        airline: null,
        railwayLine: null
      },
      cargoSalesList: null,
      secondaryCustomJobTypeList: [],
      customJobTypeList: [],
      isZY: false, // 显示中邮选项
      isHC: false,
      isShowContactPersonDetail: false, // 海创显示详细信息
      notUppercaseShipperConsigneNotify: true, // CARGO-47047 收发通大小写控制
      isUppercaseByConfig: true // CARGO-49117 是否大写
    }
  },
  computed: {
    provisionEtdLocked() {
      return !!(this.provisionLock && this.provisionLock.etdLocked)
    },
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    isLclMasterFlag() {
      return this.job.lclMasterUuid ? false : this.isEdit
    },
    carrierIdEnabled() {
      return this.isLclMasterFlag && SecurityUtil.checkOffsetAutoCompleteEnabled(this.form, 'carrierId')
    },
    localCurrency() {
      return RateUtil.localCurrencyByOffice()
    },
    cacheOffices() {
      if (this.isRegionalCommission) {
        return getBranchByLevel(this.job.opOffice)
      } else {
        return null
      }
    },
    customerEnabled() {
      // 开启参数1 且是被委托的业务，不可以改委托单位；
      if (this.config && Number(this.config.get('isNewDelegation')) === 1 && this.job.trustFromJob && this.job.relatedJobLob === this.job.lob) {
        return true
      }
      return this.readonly
    },
    // 销售分公司
    salesOffice() {
      return this.job.salesOffice
    }
  },
  created() {
    this.selectTypeNames = TYPE_NAMES
    this.creditOpen = false // 是否开启信控
    this.isSpecifiedSalesBusiness = false // 是否启用合作伙伴对应的服务人员设置(多销售模式)
    this.branchOfficeCheck = false
    this.sopConfigOpen = false
    this.isAddUserDefinedRoles = false
    this.isHC = String(cache.config.get('ToExoSystem')) === 'HC'
    this.isZY = String(cache.config.get('ToExoSystem')) === 'zy' // 显示中邮选项
    this.notUppercaseShipperConsigneNotify = Number(cache.config.get('NotUppercaseShipperConsigneNotify')) !== 1
    this.isUppercaseByConfig = Number(cache.config.get('autoUppercaseEnabled')) === 0 // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
    this.isShowContactPersonDetail = String(cache.config.get('ToExoSystem')) === 'HC'
  },
  methods: tabBookingFCLJS.methods
}
</script>

<style scoped lang="scss">
#app .section ::v-deep {
  .job-no-color.el-input {
    .el-input__inner {
      background: #99ff66 !important;
    }
  }
  .red {
    .el-input__inner {
      color: #f56c6c !important;
    }
  }
}
.poNoClass {
  /deep/ .el-input.is-disabled .el-input__inner {
    color: red !important;
  }
}
</style>
